// extracted by mini-css-extract-plugin
module.exports = {"headerLinkItem":"link-headerLinkItem--062a3","headerLink":"link-headerLink--f052a"};